<template>
  <div class="example">
  <div>
      <v-row class="ml-1 mr-1">
        <v-col xs="6" class="pb-0">
        <v-text-field
          hide-details
          type="number"
          v-model="data_1.max"
          :label="data_1.label_max"
          class="mx-4"
        >
        </v-text-field>
        </v-col>
        <v-col xs="6" class="pb-0">
          <v-text-field
            hide-details
            type="number"
            v-model="data_1.min"
            :label="data_1.label_min"
            class="mx-4"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <br>
      <v-row class="ml-1 mr-1">
        <v-col>
          <v-btn class='btn' color='green lighten-1' dark @click="updateY">Apply Y-axis</v-btn>
        </v-col>
      </v-row>
    </div>
    <p>
      <label><b>Select Theme Palette</b> </label> &nbsp;
      <select @change="updateTheme">
        <option value="palette1">palette1</option>
        <option value="palette2">palette2</option>
        <option value="palette3">palette3</option>
        <option value="palette4">palette4</option>
        <option value="palette5">palette5</option>
        <option value="palette6">palette6</option>
        <option value="palette7">palette7</option>
        <option value="palette8">palette8</option>
        <option value="palette9">palette9</option>
        <option value="palette10">palette10</option>
      </select>
    </p>
    <apexcharts
      width="100%"
      height="350"
      type="bar"
      ref="chart"
      :options="chartOptions"
      :series="series"
    ></apexcharts>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "Chart",
  components: {
    apexcharts: VueApexCharts
  },
  data: function() {
    return {
      data_1: {
        data_max: undefined,
        data_min: undefined,
        max: undefined,
        min: undefined,
        label_max: "Temperature Max",
        label_min: "Temperature Min"
      },
      data_2: {
        data_max: undefined,
        data_min: undefined,
        max: undefined,
        min: undefined,
        label_max: "Temperature Max",
        label_min: "Temperature Min"
      },
      chartOptions: {
        chart: {
          id: "basic-bar",
          animations: {
            speed: 200
          }
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          bar: {
            distributed: true
          }
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995]
        },
        yaxis: {
          min: undefined,
          max: undefined,
          opposite: true,
        }
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 30, 49]
        }
      ]
    };
  },
  methods: {
    updateTheme(e) {
      this.chartOptions = {
        theme: {
          palette: e.target.value
        }
      };
    },
    updateY() {
      var self = this;
          self.chartOptions.yaxis.min= parseFloat(self.data_1.min);
          self.chartOptions.yaxis.max= parseFloat(self.data_1.max);
      self.$refs.chart.updateOptions (self.chartOptions)
    }
  }
};
</script>